module.exports = __webpack_public_path__ + "static/media/nozzle.fdb346a6.jpg";